import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import locale files
import enTranslations from "./locales/en.json";
import arTranslations from "./locales/ar.json";

const resources = {
	en: {
		translation: enTranslations,
	},
	ar: {
		translation: arTranslations,
	},
};

i18n.use(initReactI18next).init({
	resources,
	lng: "ar", // default; will override by company profile in LanguageContext
	fallbackLng: "ar",
	interpolation: {
		escapeValue: false, // React already escapes values
	},
});

export default i18n;
